import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import '@moduviewer/design/tokens.css';
import '@moduviewer/design/base.css';
import './styles/shell.css';
import './styles/viewers.css';
import './styles/overlays.css';

const host = document.getElementById('root');
if (!host) throw new Error('#root is missing from the document');

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register the service worker so the app installs and keeps working offline
// (§29, §33). Production only — a service worker in dev caches stale bundles
// and gets in the way of iteration. Failure is silent: the app still runs, it
// just is not installable that session.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
